import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "antd";

import { LoadingIcon } from "../../CustomIcons/CustomIcons.component";

import { startCreateStatus } from "../../../actions/status.action";
import { workStatuses } from "../../../constants/constants";
import { selectStatusTypesState } from "../../../reducers/status-types.reducer";
import { selectStatusState } from "../../../reducers/status.reducer";

const StartWorkBtn: React.FC = () => {
  const dispatch = useDispatch();

  const { data: statusTypes, loading: statusTypesLoading } = useSelector(
    selectStatusTypesState
  );
  const { loading: statusLoading } = useSelector(selectStatusState);

  const isLoading =
    statusTypes.length === 0 || statusTypesLoading || statusLoading;

  const handleClickStartToWork = () => {
    const workStatusType = statusTypes.find((statusType) => {
      return statusType.id === workStatuses.working;
    });
    if (workStatusType) {
      dispatch(startCreateStatus(workStatusType));
    }
  };

  return (
    <Button
      type="primary"
      className="StartWorkBtn green-btn"
      onClick={handleClickStartToWork}
      disabled={isLoading}
    >
      {isLoading ? <LoadingIcon /> : "Enter the Office"}
    </Button>
  );
};

export { StartWorkBtn as default };
